(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', '../../styles/colors', 'react-emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('../../styles/colors'), require('react-emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.colors, global.reactEmotion);
    global.index = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _colors, _reactEmotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    counter-reset: item;\n    list-style-type: none;\n\n    & > li {\n      position: relative;\n      margin-bottom: 3.5rem;\n    }\n\n    & > li::before {\n      content: counter(item) "  ";\n      position: absolute;\n      left: -2.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 24px;\n      height: 24px;\n      border: solid 2px ', ';\n      border-radius: 50%;\n      counter-increment: item;\n      font-size: 13px;\n    '], ['\n    counter-reset: item;\n    list-style-type: none;\n\n    & > li {\n      position: relative;\n      margin-bottom: 3.5rem;\n    }\n\n    & > li::before {\n      content: counter(item) "  ";\n      position: absolute;\n      left: -2.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 24px;\n      height: 24px;\n      border: solid 2px ', ';\n      border-radius: 50%;\n      counter-increment: item;\n      font-size: 13px;\n    ']);

  var gold = _colors2.default.gold;


  var styles = {
    circleList: (0, _reactEmotion.css)(_templateObject, gold)
  };

  var CircleList = function CircleList(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
      'ol',
      { className: styles.circleList },
      children
    );
  };

  exports.default = CircleList;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/CircleList/index.js
// module id = 831
// module chunks = 1